<template>
  <div class="o-card u-padding-xsmall">
    <Tabs with-route :tabs="tabs">
      <template #batteries> <ProjectBatteries :project="project" /> </template>
      <template #cycles> <ProjectCycles :project="project" /> </template>
      <template #projects>
        <ProjectMainProjects :project="project" @refresh="refresh" />
      </template>
      <template #changedLogs> <ChangedLogs :project="project" /> </template>
      <template #permissions>
        <ProjectPermissions :project="project"
      /></template>
      <template #fileManager>
        <ProjectFileManager :project="project" />
      </template>
      <template #auxiliaryCoolingEquipment>
        <ProjectAuxiliaryCoolingEquipment
          :project="project"
          :query="{ projectId: project.id }"
        />
      </template>
    </Tabs>
  </div>
</template>

<script>
import Tabs from "@/components/Base/Tabs.vue";
import ProjectPermissions from "./ProjectPermissions.vue";
import ProjectBatteries from "./ProjectBatteries.vue";
import ProjectCycles from "./ProjectCycles.vue";
import ChangedLogs from "../ChangedLogs.vue";
import ProjectFileManager from "./ProjectFileManager.vue";
import ProjectMainProjects from "./ProjectMainProjects.vue";
import ProjectAuxiliaryCoolingEquipment from "./ProjectAuxiliaryCoolingEquipment/index.vue";
export default {
  components: {
    Tabs,
    ProjectBatteries,
    ProjectCycles,
    ProjectPermissions,
    ChangedLogs,
    ProjectFileManager,
    ProjectMainProjects,
    ProjectAuxiliaryCoolingEquipment,
  },
  props: ["project"],
  data() {
    return {
      tabs: [
        {
          label: this.$t("projectDetail.tabs.cycles"),
          tab: "cycles",
        },
        {
          label: this.$t("mainProject.title"),
          tab: "projects",
        },
        {
          label: this.$t("projectDetail.tabs.batteries"),
          tab: "batteries",
        },
        {
          label: this.$t("projectDetail.tabs.auxiliaryCoolingEquipment"),
          tab: "auxiliaryCoolingEquipment",
        },
        {
          label: this.$t("projectDetail.tabs.permissions"),
          tab: "permissions",
        },
        {
          label: this.$t("projectDetail.logs"),
          tab: "changedLogs",
        },
        {
          label: this.$t("navigation.fileManager"),
          tab: "fileManager",
        },
      ],
    };
  },
  methods: {
    refresh() {
      this.$emit("refresh");
    },
  },
};
</script>

<style></style>
